import React from 'react';

function NewLandingPageStyle() {
  return (
    <div>
      <link
        href="/static/newLandingPageContent/css/normalize.css"
        rel="stylesheet"
        type="text/css"
      />
      <link
        href="/static/newLandingPageContent/css/webflow.css"
        rel="stylesheet"
        type="text/css"
      />
      <link
        href="/static/newLandingPageContent/css/aura-health.webflow.css"
        rel="stylesheet"
        type="text/css"
      />
    </div>
  );
}

export default NewLandingPageStyle;
